import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import { Text } from 'components/core/Text';
import { ClickToShowNumberButton } from 'components/contact/ClickToShowNumberButton';

import './callCenterCTA.scss';

export function CallCenterCTA({ phone, headline, getTollfreePhoneNumber }) {
	return isEmpty(phone) ? null : (
		<div className="call-center-cta">
			<Text size="large" family="rounded">{ headline }</Text>
			<ClickToShowNumberButton
				className="phone-number-button"
				outline
				size="standard"
				fetchPhoneNumber={getTollfreePhoneNumber}
			/>
		</div>

	);
}

CallCenterCTA.propTypes = {
	phone: PropTypes.object.isRequired,
	headline: PropTypes.string,
	getTollfreePhoneNumber: PropTypes.func
};

CallCenterCTA.defaultProps = {
	headline: "Can't decide? Let SpareFoot help you choose."
};

export default CallCenterCTA;
